"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var angular_utils_1 = require("../util/angular/angular-utils");
var Authentication_service_1 = require("./authentication/Authentication.service");
var UserService = /** @class */ (function () {
    function UserService(authenticationService) {
        this.authenticationService = authenticationService;
    }
    UserService.prototype.getAccessToken = function (withType) {
        if (withType === void 0) { withType = true; }
        return this.authenticationService.authHelper.getAccessToken(withType);
    };
    /**
     * @deprecated
     * **Please stop using this!**
     *
     * Please use **UserService.getSecurityCredentials()** instead if you are need these props
     * ``` loginInfo.tenant
     *  loginInfo.username
     *  loginInfo.userid
     *  loginInfo.accessKey
     *  loginInfo.isSSO
     *  loginInfo.SSODisabled
     *  loginInfo.rememberMeToken
     *```
     * Otherwise, please see the progress bellow
     * 1. Check https://seismic.atlassian.net/browse/FEARCH-145 for analyzing
     * 2. Check https://seismic.atlassian.net/browse/FEARCH-395 for the following actions
     * 3. Check https://seismic-software.slack.com/archives/C028EJWVCC8 for more announcements
     */
    UserService.prototype.getLoginInfo = function () {
        console.warn('SeismicCommon: userService.getLoginInfo() is deprecated and going to be removed by Sep 6, please stop using this!');
        return angular_utils_1.getLoginInfoInCommonHelper();
    };
    UserService.prototype.getSecurityCredentials = function () {
        return this.securityCredentials;
    };
    /**
     * Only for initialization
     */
    UserService.prototype.initSecurityCredentials = function (securityCredentials) {
        // Freezing for avoiding accidental mutation
        // Copying for freezing the original data
        this.securityCredentials = Object.freeze(__assign({}, securityCredentials));
    };
    UserService.prototype.getTenant = function () {
        return window.tenant;
    };
    UserService.prototype.isLoggedIn = function () {
        return false;
    };
    UserService = __decorate([
        CommonService_decorator_1.CommonService('UserService'),
        __metadata("design:paramtypes", [Authentication_service_1.AuthenticationService])
    ], UserService);
    return UserService;
}());
exports.UserService = UserService;
//# sourceMappingURL=User.service.js.map